export const toPascalCase = (s: string): string =>
  s.replace(/(\w)(\w*)/g, (g0, g1, g2) => g1.toUpperCase() + g2.toLowerCase());

const encodeRFC = (str: string) =>
  encodeURIComponent(str).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`);

/**
 * Serialises request params to a query string. Arrays repeat the key.
 *
 * Falsy values other than `0` — including `false` — are left out. That is
 * load-bearing: some backend handlers read a flag as `!!query.flag`, where the
 * string "false" is truthy (rate card options' `showDraft` would then return
 * drafts). Omit a flag to mean false; do not change this filter without
 * checking each endpoint parses booleans strictly.
 *
 * @param params - Query params; values are stringified.
 */
export const buildQueryString = (params: Record<string, unknown>): string => {
  const searchParams = new URLSearchParams();

  Object.entries(params)
    .filter(([, value]) => !!value || value === 0)
    .forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          searchParams.append(key, encodeRFC(`${item}`));
        });
      } else {
        searchParams.set(key, encodeRFC(`${value}`));
      }
    });

  return decodeURIComponent(searchParams.toString());
};

export const truncateString = (str: string, num: number): string => {
  if (str.length > num) {
    return `${str.slice(0, num)}...`;
  }
  return str;
};
